// extracted by mini-css-extract-plugin
export var desc = "style-module--desc--8b76e";
export var inner = "style-module--inner--1bc2e";
export var reg = "style-module--reg--bc380";
export var small = "style-module--small--7e65c";
export var time = "style-module--time--673c7";
export var title = "style-module--title--ca224";
export var widget = "style-module--widget--22367";